import { BufferWriter, Writer } from "protobufjs";

import { IApiClient } from "../client";
import { api, entity } from "../rpc/api";
import { getToken } from "./bind_token";

class ContractCustomerReportAPI {
  constructor(readonly apiClient: IApiClient) {}

  public getAllByContract(
    contractId: string
  ): Promise<entity.IContractCustomerReport[]> {
    return new Promise<entity.IContractCustomerReport[]>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: entity.ContractID = new entity.ContractID();
          req.id = contractId;
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.ContractCustomerReportService/GetAllByContract",
            token,
            entity.ContractID.encode(req, writer).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          const res = entity.ContractCustomerReportList.decode(binary);
          resolve(res.items);
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  }

  public get = (id: string): Promise<entity.IContractCustomerReport> => {
    return new Promise<entity.IContractCustomerReport>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: entity.ContractCustomerReportID =
            new entity.ContractCustomerReportID();
          req.id = id;
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.ContractCustomerReportService/Get",
            token,
            entity.ContractCustomerReportID.encode(req, writer).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          const res: entity.ContractCustomerReport =
            entity.ContractCustomerReport.decode(binary);
          resolve(res);
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  };

  public create = (
    contractId: string,
    targetYM: string,
    detail: string,
    satisfactionLevel: entity.ContractOperationReport.SatisfactionLevel,
    continuationLevel: entity.ContractOperationReport.ContinuationLevel,
    supportRequest: string,
    otherRequest: string,
    endScheduledYM: string
  ): Promise<entity.IContractCustomerReport> => {
    return new Promise<entity.IContractCustomerReport>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: api.CreateContractCustomerReportRequest =
            new api.CreateContractCustomerReportRequest();
          req.contractID = contractId;
          req.targetYM = targetYM;
          req.detail = detail;
          req.satisfactionLevel = satisfactionLevel;
          req.continuationLevel = continuationLevel;
          req.supportRequest = supportRequest;
          req.otherRequest = otherRequest;
          req.endScheduledYM = endScheduledYM;
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.ContractCustomerReportService/Create",
            token,
            api.CreateContractCustomerReportRequest.encode(
              req,
              writer
            ).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          const res: entity.ContractCustomerReport =
            entity.ContractCustomerReport.decode(binary);
          resolve(res);
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  };
}

const createContractCustomerReportAPI = (apiClient: IApiClient) => {
  return new ContractCustomerReportAPI(apiClient);
};

export { createContractCustomerReportAPI };



// WEBPACK FOOTER //
// ./src/infra/api/service/contract_customer_report_api.ts